
































import Vue from "vue";
import ZenyaDialog from "@/components/dialogs/ZenyaDialog.vue";
import PrintDocument from "@/components/modules/document/PrintDocument.vue";
import { DocumentVersionInfo } from "@/types/document/documentVersionInfo";
import { DocumentRoute } from "@/enums";
import DocumentToolbarAction from "@/components/modules/document/toolbar/DocumentToolbarAction.vue";
import storeHelper from "@/store/store-helper";
export default Vue.extend({
    name: "PrintDocumentAction",
    components: { ZenyaDialog, PrintDocument, DocumentToolbarAction },
    props: {
        documentProperties: Object as () => DocumentVersionInfo,
        documentRoute: String as () => DocumentRoute,
        isButton: Boolean,
        enable: { default: true }
    },
    data: function () {
        return {
            showPrintDocumentDialog: false,
            hidePrintCancelButton: false,
            hidePrintOkButton: false,
            printDialogSizeXL: false,
            route: { ...DocumentRoute }
        };
    },
    watch: {
        showPrintDocumentDialog: function () {
            storeHelper.siteStore.setIsDialogDisplayed(this.showPrintDocumentDialog);
            if (!this.showPrintDocumentDialog) {
                this.printDialogSizeXL = false;
            }
        }
    },
    methods: {
        showPrintDialog(): void {
            this.showPrintDocumentDialog = true;
            this.hidePrintCancelButton = false;
            this.hidePrintOkButton = false;
        },
        hidePrintPopupCancelButton(): void {
            this.hidePrintCancelButton = true;
        },
        hidePrintPopupOkButton(): void {
            this.hidePrintOkButton = true;
        },
        closePrintDialog() {
            this.showPrintDocumentDialog = false;
        }
    }
});
